import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UpsiParamService {

  constructor(private httpService: HttpService,private http: HttpClient) { }

  setOption(item) {
    var request = {
      URL: "upsi/setOption",
      DATA: item
    }
    console.log("request", request)
    return this.httpService.post(request);
  }

  getOption() {
    var request = {
      URL: "upsi/getOption",
    }
    console.log("request", request)
    return this.httpService.get(request);
  }

  
  addUPSI(newSharer) {
    var request = {
        URL: "upsidetails/add",
        DATA: newSharer
    }
    return this.httpService.post(request);        
}

uploadFile(id, formData) {
    var request = {
        URL: "upsidetails/fileUpload/"+ id,
        DATA: formData
    }
    return this.httpService.post(request);        
}

updateUPSI(id, object)  {
    var request = {
        URL: "upsidetails/update/"+ id,
        DATA: object
    }
    return this.httpService.post(request);        
}

deleteFile(id)  {
    var request = {
        URL: "upsidetails/deleteFile/"+ id
    }
    return this.httpService.get(request);        
}

addToUPSIDetails(newSharer) {
    var request = {
        URL: "upsi/addToUPSIDetails",
        DATA: newSharer
    }
    return this.httpService.post(request);        
}


getUpsiBulkData() {
    let request = { URL : "upsi/blukdata"}
    return this.httpService.get(request)
}

getUpsiBulkDataById(id){
    let request = { URL : "upsi/getBulkDataById/" + id}
    return this.httpService.get(request)
}

deleteUPSIBulkDataById(id) {
    let request = { URL : "upsi/deleteBlukdataById/" + id}
    return this.httpService.get(request)
}

updateBulkUPSI(id, object)  {
    var request = {
        URL: "upsi/updateBlukdataById/"+ id,
        DATA: object
    }
    return this.httpService.post(request);        
}

// downloadSample(companyId){
//     let request = { URL : "upsi/downloadSample/" + companyId}
//     return this.http.get(environment.pssServerUrl + request.URL, {headers: this.httpService.addHeaders(), responseType: 'json'})
// }

downloadSample(companyId: string): Observable<Blob> {
  const request = { URL: "upsi/downloadSample/" + companyId };
  return this.http.get(
    environment.pssServerUrl + request.URL,
    {
      headers: this.httpService.addHeaders(),
      responseType: 'blob'  // 👈 FIXED HERE
    }
  );
}


addSelectedUpsiBulkData(object){
    var request = {
        URL: "upsi/addMultipleUPSIDetails/",
        DATA: object
    }
    return this.httpService.post(request);  
}

deleteSelectedUpsiBulkData(object){
    var request = {
        URL: "upsi/deleteMultipleBulkData/",
        DATA: object
    }
    return this.httpService.post(request);  
}

getEmailsLog(paramData) {
    var request = {
      URL: "emailsUpsiLog",
      DATA: paramData
    }
    return this.httpService.post(request);
  }
}
